import {RecordAuditDefinitionTask} from '../types/RecordAuditDefinitionFormValue';

export const recordAuditDefinitionTaskFactory = (): RecordAuditDefinitionTask => ({
  description: '',
  isMandatory: false,
  fileRequired: false,
  weight: 1,
  sectionId: null,
});
